/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import TotalAuditeeIcon from "../../../../icons/totalAuditee.svg?react";
import AverageIcon from "../../../../icons/AverageRespTime.svg?react";
import MaximumRespTime from "../../../../icons/maximumRespTime.svg?react";
import MinimumRespTime from "../../../../icons/MininumRespTime.svg?react";
import { getResponseAnalysisByTime, getAuditeeQuestionAnalysis } from '../../../../api/common';
import { ArrowRight } from "lucide-react";
import "./analysis.scss";
import ResponseTimelineModal from '../responseTimeLineModal';
import { formatMinutes, resolveLogoUrl } from '../../../../utils';

interface ResponseTimeAnalysisProps {
    responseAnalysisData: any | null | undefined;
    auditID: any;
}
interface StatItem {
    label: string;
    value: string | number;
    icon: React.ReactNode;
    iconBg: string;
}

const ResponseTimeAnalysis: React.FC<ResponseTimeAnalysisProps> = ({ responseAnalysisData, auditID }) => {

    const [showModal, setShowModal] = useState<number | null>(null);
    const [responseAnalysisTimeData, setResponseAnalysisTimeData] = useState<any>([]);
    const [questionStatus, setQuestionStatus] = useState<any>(null);

    const tabs = responseAnalysisData?.organizations && Array.isArray(responseAnalysisData.organizations)
        ? responseAnalysisData.organizations.map((data: any) => ({
            label: data?.name,
            value: data?.name,
            logo: data?.organizationLogo,
            id: data?.id
        }))
        : [];


    const [activeOrg, setActiveOrg] = useState(tabs[0]);
    useEffect(() => {
        if (responseAnalysisData?.organizations && Array.isArray(responseAnalysisData.organizations)) {
            const tabs = responseAnalysisData?.organizations && Array.isArray(responseAnalysisData.organizations)
                ? responseAnalysisData.organizations.map((data: any) => ({
                    label: data?.name,
                    value: data?.name,
                    logo: data?.organizationLogo,
                    id: data?.id
                }))
                : [];
            setActiveOrg(tabs[0]);
            getResponseAnalysisByTime(auditID, Number(tabs[0]?.id)).then((response) => {
                setResponseAnalysisTimeData(response);
            });
        }
    }, [responseAnalysisData]);

    const handleQuestionClick = (questionID: string) => {
        getAuditeeQuestionAnalysis(auditID, Number(questionID), activeOrg?.id).then((response) => {
            setQuestionStatus(response);
        });
    }

    const handletabChange = (org: any) => {
        setActiveOrg(org);
        getResponseAnalysisByTime(auditID, Number(org?.id)).then((response) => {
            setResponseAnalysisTimeData(response);
        });
    };

    const stats: StatItem[] = [
        {
            label: "Total Auditee",
            value: responseAnalysisTimeData?.totalAuditees ?? "0",
            icon: <TotalAuditeeIcon />,
            iconBg: "#EEF0FF"
        },
        {
            label: "Average Response Time",
            value: formatMinutes(responseAnalysisTimeData?.averageResponseTime) ?? "0h",
            icon: <AverageIcon />,
            iconBg: "#EEF1FF"
        },
        {
            label: "Maximum Response Time",
            value: formatMinutes(responseAnalysisTimeData?.maxResponseTime) ?? "0h",
            icon: <MaximumRespTime />,
            iconBg: "#FFECEC"
        },
        {
            label: "Minimum Response Time",
            value: formatMinutes(responseAnalysisTimeData?.minResponseTime) ?? "0h",
            icon: <MinimumRespTime />,
            iconBg: "#E9FFF5"
        }
    ];
    return (
        <Card.Body className="response-time-analysis">
            <div className="tabs-container my-4">
                {tabs?.map((org: any, index: any) => {
                    const isActive = activeOrg?.label === org.label;

                    return (
                        <div
                            key={org.value}
                            className={`tab-item-wrapper ${isActive ? "tab-active" : ""}`}
                        >
                            <button
                                className={`tab-btn ${isActive ? "tab-btn-active" : ""}`}
                                onClick={() => handletabChange(org)}
                            >
                                <img src={resolveLogoUrl(org.logo) ?? undefined} className="tab-icon" alt="" />
                                <span>{org.label}</span>
                            </button>

                            {index < tabs.length - 1 &&
                                !isActive &&
                                !(activeOrg?.label === tabs[index + 1].label) && (
                                    <div className="tab-divider" />
                                )}
                        </div>
                    );
                })}
            </div>
            <h6
                className="fw-bold mb-4"
                style={{ fontSize: "15px", color: "#102250" }}
            >
                Question Response Time Analysis
            </h6>
            <p style={{ fontWeight: 500 }}>Time spent by auditees to achieve satisfactory response </p>

            <Row className="g-3">
                {responseAnalysisTimeData && stats.map((item, index) => (
                    <Col key={index} lg={3} md={6} sm={6} xs={12}>
                        <Card className={"statCard"}>
                            <div className={"cardLeft"}>
                                <p className={"label"}>{item.label}</p>
                                <p className={"value"}>{item.value}</p>
                                <div className={"iconBox"} style={{ backgroundColor: item.iconBg }}>
                                    {item.icon}
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>

            <div className="qc-wrapper my-3">
                {responseAnalysisTimeData?.questionStatus?.map((q: any, index: number) => (
                    <div key={q.questionId} className="qc-card">

                        <h3 className="qc-title">Question {index + 1}</h3>

                        {/* question text */}
                        <p className="qc-question">{q?.questionText}</p>

                        {/* Completion rate → You must calculate it or remove if not available */}
                        <div className="qc-completion-row">
                            <span className="qc-completion-label">Completion Rate</span>
                            <span className="qc-completion-value">
                                {q?.completionRate ?? 0}%
                            </span>
                        </div>

                        <div className="qc-progress-bar">
                            <div
                                className="qc-progress-fill"
                                style={{ width: `${q?.completionRate ?? 0}%` }}
                            ></div>
                        </div>

                        <button className="qc-view-details" onClick={() => {
                            setShowModal(q.questionId);
                            handleQuestionClick(q.questionId)
                        }}>
                            View Details <ArrowRight size={16} />
                        </button>

                        {/* Pass only the responses for this question */}
                        <ResponseTimelineModal
                            show={showModal === q.questionId}
                            onClose={() => setShowModal(null)}
                            apiData={questionStatus ?? {}}
                            questionId={index + 1}
                            questionText={q?.questionText}
                            averageResponseTime={questionStatus?.responseTime || "0h"}
                        />
                    </div>
                ))}

            </div>

        </Card.Body>
    );
};

export default ResponseTimeAnalysis;